<template>
  <section class="banco">
    <h2>Dados Bancários:</h2>

    <!-- <label for="bank" style="font-size: 30px"
      >Cartões de crédito e débito</label
    > -->
    <hr />
    <br />

    <label for="lembrar">Código do banco:</label>
    <ValidationProvider v-slot="{ errors }" rules="required|numeric">
      <input
        v-model="bank.cod_banco"
        class="campo"
        type="text"
        placeholder="Código do banco"
        :disabled="isDisable >= 1"
      />
      <span class="error">{{ errors[0] }}</span>
    </ValidationProvider>

    <label for="lembrar">Nome do banco:</label>
    <ValidationProvider v-slot="{ errors }" rules="required">
      <input
        v-model="bank.nome_banco"
        class="campo"
        type="text"
        placeholder="Nome do banco"
        :disabled="isDisable >= 1"
      />
      <span class="error">{{ errors[0] }}</span>
    </ValidationProvider>

    <label for="lembrar">Agência:</label>
    <ValidationProvider v-slot="{ errors }" rules="required|numeric">
      <input
        v-model="bank.agencia"
        class="campo"
        type="text"
        placeholder="Agência"
        :disabled="isDisable >= 1"
      />
      <span class="error">{{ errors[0] }}</span>
    </ValidationProvider>

    <label for="lembrar">Conta:</label>
    <ValidationProvider v-slot="{ errors }" rules="required|numeric">
      <input
        v-model="bank.conta"
        class="campo"
        type="text"
        placeholder="Conta"
        :disabled="isDisable >= 1"
      />
      <span class="error">{{ errors[0] }}</span>
    </ValidationProvider>

    <label for="lembrar">Operação:</label>
    <ValidationProvider v-slot="{ errors }" rules="required|numeric">
      <input
        v-model="bank.operacao"
        class="campo"
        type="text"
        placeholder="Operação"
        :disabled="isDisable >= 1"
      />
      <span class="error">{{ errors[0] }}</span>
    </ValidationProvider>

    <label for="lembrar">CPF:</label>
    <ValidationProvider v-slot="{ errors }" rules="required|cpf">
      <input
        v-mask="'###.###.###-##'"
        v-model="bank.cpf"
        class="campo"
        type="text"
        placeholder="CPF"
        :disabled="isDisable >= 1"
      />
      <span class="error">{{ errors[0] }}</span>
    </ValidationProvider>

    <div style="display:flex">
      <div style="margin-top: 20px">
        <button @click="saveBank">Salvar</button>
      </div>
      <div style="margin-top: 20px" @click="editInput">
        <button style="background-color: #67C23A; margin-left:10px">
          Editar
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import ValidateField from '@/service/mixins/validation.js';
import { mask } from 'vue-the-mask';
import axios from 'axios';
import TeacherService from '../../../../../service/TeacherService/TeacherService.js';

const app = new TeacherService();

export default {
  components: {
    ValidationProvider,
  },
  mixins: [ValidateField],
  directives: { mask },
  data() {
    return {
      isDisable: 999,
      bank: {
        cod_banco: '',
        nome_banco: '',
        agencia: '',
        conta: '',
        operacao: '',
        cpf: '',
      },
    };
  },

  async mounted() {
    await this.getUser();
    console.log(this.bank);
  },

  methods: {
    async getUser() {
      // this.$set(this, "userToUpdate", Object.assign({}, this.resume))
      const id = localStorage.getItem('user');
      const { data } = await axios.get(`${process.env.VUE_APP_API}/user/${id}`);
      let pos = data.accountBank.length - 1;
      this.bank = data.accountBank[pos];
    },
    editInput() {
      if (this.isDisable > 0) {
        this.isDisable = 0;
      } else {
        this.isDisable = 999;
      }

      console.log(this.isDisable);
    },
    async saveBank() {
      const id = localStorage.getItem('user');
      app.createBank(this.bank, id);
    },
  },
};
</script>

<style lang="scss" scoped>
.error {
  color: red !important;
  display: block;
}
.banco {
  background: #fff;
  max-width: 910px;
  margin: auto;
  padding: 26px 30px 24px 24px;
  border-top: 1px solid #e4e7eb;
  border-bottom: 1px solid #b3b6bb;

  h2 {
    color: #3a3b3f;
    font-weight: 700;
    font-size: 1.5rem;
    margin-bottom: 20px;

    span {
      display: inline-block;
      margin-left: 16px;
      color: #66788a;
      font-size: 0.875rem;
      font-weight: 400;
    }
  }

  label {
    color: #000000;
    font-size: 1.2rem;
  }
  .campo {
    width: 100%;
    margin-bottom: 24px;
    font-size: 16px;
    padding: 16px;
    border: 1px solid rgba(102, 120, 138, 0.3);
    border-radius: 4px;
  }

  span {
    color: #3a3b3f;
    font-weight: 700;
    margin-bottom: 24px;
  }

  input::placeholder {
    color: #dadada;
  }

  a {
    color: #1665d8;
    margin-bottom: 24px;
  }

  button {
    color: white;
    background: #1d43ff;
    border: none;
    font-size: 0.875;
    padding: 12px 48px;
    border-radius: 4px;
    font-weight: 700;
  }
  // }
}

@media (max-width: 768px) {
  #conta {
    .container {
      h2 {
        margin-bottom: 0;

        span {
          margin: 0;
          padding: 12px 0;
        }
      }

      button {
        width: 100%;
      }
    }
  }
}
</style>
